<template>
    <div class="chance">
        <div class="home-content">
            <!-- 推荐 -->
            <div class="home-t">
                <!-- <div class="home-t-newLeft" v-for="(item,index) in chanceTypeList.slice(0,2)" :key="index">
          <div class="header">{{item.nameEn}}</div>
           数量最多13个 
          <template v-if="item.list.items.length">
            <div v-for="(itm,idx) in item.list.items.slice(0,13)" :key="idx" class="matter" @click="linkToChance(itm)">
              <span :title="itm.information">{{itm.information}}</span>
              <span>{{itm.inTime | moment('YYYY/MM/DD')}}</span>
            </div>
          </template>
<div v-else style="text-align:center;line-height:100px;">No Data！</div>
<div class="seeMore" @click="$router.push('/chance-typeEn?id=' + item.id + '&name=' + item.nameEn)">View more</div>
</div> -->


                <div class="chance-item">
                    <div class="chance-item-header">Purchasing</div>
                    <div style="height: 800px;overflow: overlay;">
                        <div class="need-list list_wrap" v-if="hallList.length">

                            <div v-for="(item, index) in hallList" :key="index" style="margin:20px 0px ">
                                <div class="item" style="">
                                    <!-- @click="linkToChance(item)" -->
                                    <div class="item_top">
                                        <div class="logo" style="margin-right: 10px;">
                                            <img :src="item.headImg"
                                                style="border-radius: 50%;width: 60px;height: 60px;"
                                                v-if="item.headImg">
                                            <img src="../../../../assets/img/cmef-tx.png"
                                                style="border-radius: 50%;width: 60px;height: 60px;" v-else />
                                        </div>
                                        <div class="details">
                                            <div class="line"
                                                style="justify-content: space-between;display: flex;align-items: center;">

                                                <div>
                                                    <span class="name" style="width: 200px;display: block;">{{ item.name
                                                        }}</span>
                                                    <span class="job" v-if="item.jobTitle">{{ item.jobTitle }}</span>
                                                </div>
                                                <div class="create_time">
                                                    {{ item.inDate }}
                                                </div>

                                            </div>

                                            <div class="info2" style="display: flex;max-width:290px;margin-top:12px">
                                                <span class="rn-type" v-if="item.publishType == '医疗器械成品'"
                                                    style="color:#EE1c5D">{{
                                                    item.publishType }}</span>
                                                <span class="rn-type"
                                                    v-if="(item.publishType == '医疗器械成品' && item.productType) || (item.publishType == '医疗器械成品' && item.type2)"
                                                    style="color:#16D1D1;max-width: 66%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                                                    <span v-if="item.productType || item.type2">{{ item.productType ?
                                                        item.productType : item.type2 }}</span>
                                                </span>
                                                <span class="rn-type" v-if="item.publishType == '制造供应链'"
                                                    style="color:#EE1c5D">{{
                                                    item.publishType }}</span>
                                                <span class="rn-type"
                                                    v-if="(item.publishType == '制造供应链' && item.productType) || (item.publishType == '制造供应链' && item.type2)"
                                                    style="color:#16D1D1;max-width: 66%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                                                    <span v-if="item.productType || item.type2">{{ item.productType ?
                                                        item.productType : item.type2 }}</span>

                                                </span>
                                                <span class="rn-type" v-if="item.publishType == '招商发布'"
                                                    style="color:#EE1c5D">{{
                                                    item.publishType }}</span>

                                                <span class="rn-type"
                                                    v-if="(item.publishType == '招商发布' && item.supplyProductName) || (item.publishType == '招商发布' && item.information)"
                                                    style="color:#16D1D1;max-width: 66%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                                                    <span v-if="item.supplyProductName || item.information">{{
                                                        item.supplyProductName ? item.supplyProductName :
                                                        item.information }}
                                                    </span>
                                                </span>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="item_bottom" style="font-size: 14px;">
                                        <div class="daili marTop15">
                                            <span class="span1">
                                                <span class="color9">Purchase deadline：</span>
                                                {{ item.endTime }}
                                            </span>
                                        </div>
                                        <div class="daili marTop15"
                                            style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                                            <span class="span2">
                                                <span class="color9">Procurement Description：</span>
                                                {{ item.remark }}
                                            </span>
                                        </div>
                                        <div style="width:100%;height:1px; background:#f5f5f5;margin-top:10px"> </div>



                                        <div style="margin-top:10px;" class="flex_between_center">
                                            <div>
                                                <span class="color9">Source：</span>
                                                {{ item.companyName ? item.companyName : "无" }}
                                            </div>
                                            <div style="cursor: pointer;color:#EE1c5D;" @click="goDetailInfo(item)">
                                                Click communicate</div>
                                        </div>

                                        <div class="bottom-btn">
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
                <div class="chance-item">
                    <div class="chance-item-header">Supplying</div>
                    <div style="height: 800px;overflow: overlay;">
                        <div class="need-list list_wrap" v-if="hallListzs.length">

                            <div v-for="(item, index) in hallListzs" :key="index" style="margin:20px 0px ">
                                <div class="item" style="">
                                    <!-- @click="linkToChance(item)" -->
                                    <div class="item_top">
                                        <div class="logo" style="margin-right: 10px;">
                                            <img :src="item.headImg"
                                                style="border-radius: 50%;width: 60px;height: 60px;"
                                                v-if="item.headImg">
                                            <img src="../../../../assets/img/cmef-tx.png"
                                                style="border-radius: 50%;width: 60px;height: 60px;" v-else />
                                        </div>
                                        <div class="details">
                                            <div class="line"
                                                style="justify-content: space-between;display: flex;align-items: center;">

                                                <div>
                                                    <span class="name" style="width: 200px;display: block;">{{ item.name
                                                        }}</span>
                                                    <span class="job" v-if="item.jobTitle">{{ item.jobTitle }}</span>
                                                </div>
                                                <div class="create_time">
                                                    {{ item.inDate }}
                                                </div>

                                            </div>

                                            <div class="info2" style="display: flex;max-width:290px;margin-top:12px">
                                                <span class="rn-type" v-if="item.publishType == '医疗器械成品'"
                                                    style="color:#EE1c5D">{{
                                                    item.publishType }}</span>
                                                <span class="rn-type"
                                                    v-if="(item.publishType == '医疗器械成品' && item.productType) || (item.publishType == '医疗器械成品' && item.type2)"
                                                    style="color:#16D1D1;max-width: 66%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                                                    <span v-if="item.productType || item.type2">{{ item.productType ?
                                                        item.productType : item.type2 }}</span>
                                                </span>
                                                <span class="rn-type" v-if="item.publishType == '制造供应链'"
                                                    style="color:#EE1c5D">{{
                                                    item.publishType }}</span>
                                                <span class="rn-type"
                                                    v-if="(item.publishType == '制造供应链' && item.productType) || (item.publishType == '制造供应链' && item.type2)"
                                                    style="color:#16D1D1;max-width: 66%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                                                    <span v-if="item.productType || item.type2">{{ item.productType ?
                                                        item.productType : item.type2 }}</span>

                                                </span>
                                                <span class="rn-type" v-if="item.publishType == '招商发布'"
                                                    style="color:#EE1c5D">{{
                                                    item.publishType }}</span>

                                                <span class="rn-type"
                                                    v-if="(item.publishType == '招商发布' && item.supplyProductName) || (item.publishType == '招商发布' && item.information)"
                                                    style="color:#16D1D1;max-width: 66%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                                                    <span v-if="item.supplyProductName || item.information">{{
                                                        item.supplyProductName ? item.supplyProductName :
                                                        item.information }}
                                                    </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="item_bottom" style="font-size: 14px;" v-if='item.fromType == 0'>
                                        <div class="daili marTop15" style="display: flex;">
                                            <p class="span1"
                                                style="width: 50%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                                                <span class="color9">Investment category：</span>
                                                {{ item.idnentityType ? item.idnentityType : "无" }}
                                            </p>
                                            <p class="span1" style="margin-left: 20px;">
                                                <span class="color9">Supply cycle：</span>
                                                {{ item.supplyDate ? item.supplyDate : "无" }}
                                            </p>
                                        </div>
                                        <div class="daili marTop15"
                                            style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;display: flex;">
                                            <p class="span2" style="width: 50%;overflow: hidden;">
                                                <span class="color9">Investment area：</span>
                                                {{ item.productArea ? item.productArea : "无" }}
                                            </p>
                                            <p class="span2" style="margin-left: 20px;">
                                                <span class="color9">Supply quantity：</span>
                                                {{ item.supplyCount ? item.supplyCount : "无" }}
                                                <span v-if='item.supplyCount'>台</span>
                                            </p>
                                        </div>

                                        <div style="width:100%;height:1px; background:#f5f5f5;margin-top:10px"> </div>


                                        <div style="margin-top:10px;" class="flex_between_center">
                                            <div>
                                                <span class="color9">Source：</span>
                                                {{ item.fromCompany ? item.fromCompany : "无" }}
                                            </div>
                                            <div style="cursor: pointer;color:#EE1c5D;" @click="goDetailInfo(item)">
                                                Click communicate</div>
                                        </div>


                                        <div class="bottom-btn">
                                        </div>
                                    </div>

                                    <div class="item_bottom" style="font-size: 14px;" v-if='item.fromType == 1'>
                                        <div class="daili marTop15" style="display: flex;">
                                            <p class="span1"
                                                style="width: 50%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                                                <span class="color9">CompanyName：</span>
                                                {{ item.companyName ? item.companyName : "无" }}
                                            </p>
                                            <p class="span1" style="margin-left: 20px;">
                                                <span class="color9">Product name：</span>
                                                {{ item.personProdcutName ? item.personProdcutName : "无" }}
                                            </p>
                                        </div>
                                        <div class="daili marTop15"
                                            style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                                            <span class="span2">
                                                <span class="color9">Product Introduction：</span>
                                                {{ item.personProductIntroduction ? item.personProductIntroduction : "无"
                                                }}
                                            </span>
                                        </div>

                                        <div style="margin-top:10px;" class="flex_between_center">
                                            <div>

                                            </div>
                                            <div style="cursor: pointer;color:#EE1c5D;" @click="goDetailInfo(item)">
                                                Click communicate</div>
                                        </div>


                                        <div class="bottom-btn">
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="home-t-right">
                    <exRelease :newChanceList="newChanceList" @finish="getChanceList" @updateList="updateList"
                        ref="release"></exRelease>
                </div>

                <div class="clear"></div>

            </div>

            <!-- <div class="home-t-left">
            <h2 class="home-title">推荐商机</h2>
            <div class="chance-list" v-if="chanceList.length">
                <div class="chance-list-one" 
                v-for="(itme,index) in chanceList.slice(0,8)" 
                :key="index" 
                :class="index > 3 ? 'three' : ''"
                @click="linkToChance(itme)"
                >
                    <div class="one-top">
                        <img :src="itme.headImg" alt="" v-if="itme.headImg">
                        <img src="@/assets/img/empty.png" alt="" v-else>
                        <p>{{itme.title}}</p>
                    </div>
                    <div class="one-bot">
                        <p>
                            <span class="time">{{itme.inTime | moment('YYYY/MM/DD')}}</span>
                            <span class="view">
                              <i class="icon iconfont icon-zhiboguankanshu"></i>
                              {{itme.viewCount > 9999 ? (Math.floor(itme.viewCount/1000)/10) + 'W' :itme.viewCount}}
                            </span>
                        </p>
                        <div class="one-list-img"  v-if="itme.photo.length">
                            <div class="img" v-for="(item,index) in itme.photo" :key="index">
                              <img :src="item" alt="" v-if="item">
                              <img src="@/assets/img/empty.png" alt="" v-else>
                            </div>
                        </div>
                        <h3 :title="itme.information">{{ itme.photo.length == 0 ? (itme.information.length > 58 ? itme.information.slice(0,58) + '...' : itme.information) 
                          : (itme.photo.length > 3 ? (itme.information.length > 18 ? itme.information.slice(0,18) + '...' : itme.information) : (itme.information.length > 40 ? itme.information.slice(0,40) + '...' : itme.information))}}</h3>
                    </div>
                </div>
            </div>
            <div class="no-msg" v-else>
                暂无数据！
            </div>
        </div> -->

        </div>
        <!-- 品牌企业 -->
        <div class="home-c-brand">
            <h2>Brand Companies</h2>
            <brandCard></brandCard>
        </div>
        <!-- 所有商机 -->
        <!-- <div class="home-b-chance">
        <h2>全部商机</h2>
        <div class="chance-list" v-if="chanceList.length">
            <div class="chance-list-one" 
            v-for="(itme,index) in chanceList" 
            :key="index"
            @click="linkToChance(itme)"
            >
                <div class="one-top">
                    <img :src="itme.headImg" alt="" v-if="itme.headImg">
                    <img src="@/assets/img/empty.png" alt="" v-else>
                    <p>{{itme.title}}</p>
                </div>
                <div class="one-bot">
                    <p>
                        <span class="time">{{itme.inTime | moment('YYYY/MM/DD')}}</span>
                        <span class="view">
                          <i class="icon iconfont icon-zhiboguankanshu"></i>
                         {{itme.viewCount > 9999 ? (Math.floor(itme.viewCount/1000)/10) + 'W' :itme.viewCount}}
                        </span>
                    </p>
                    <div class="one-list-img"  v-if="itme.photo.length">
                        <div class="img" v-for="(item,index) in itme.photo" :key="index">
                          <img :src="item" alt="" v-if="item">
                          <img src="@/assets/img/empty.png" alt="" v-else>
                        </div>
                    </div>
                    <h3 :title="itme.information">{{ itme.photo.length == 0 ? (itme.information.length > 58 ? itme.information.slice(0,58) + '...' : itme.information) 
                          : (itme.photo.length > 3 ? (itme.information.length > 18 ? itme.information.slice(0,18) + '...' : itme.information) : (itme.information.length > 40 ? itme.information.slice(0,40) + '...' : itme.information))}}</h3>
                </div>
            </div>
            <div class="more">
              <div class="more f-csp" v-if="donetTip"> 
                <span>No more</span> 
              </div>
              <div class="more f-csp" @click="loadList()" v-else> 
                <span>加载More</span> 
              </div> 
            </div>
        </div>
        <div class="no-msg" v-else>
            暂无数据！
        </div>
      </div> -->
    </div>
    </div>
</template>

<script>
// import swiperCommon from "@components/swiper-common";
import exRelease from "./ex-release";
import brandCard from "./brand-card";
import { mapActions, mapGetters, mapMutations } from "vuex";
import axios from 'axios'


export default {
    name: "chance",
    data () {
        return {
            chanceList: [], //商机列表
            pageIndex: 1,
            pageSize: 18, // 一页18条；
            donetTip: false,
            newChanceList: [], // 最新商机
            chanceTypeList: [],

            hallList: [],
            hallListzs: [],


        };
    },
    components: {
        // swiperCommon, 
        exRelease,
        brandCard
    },
    computed: {
        ...mapGetters({
            exhibitionId: 'getExhibitionId',
            user: "getUser",
            login_is: 'getLogin',
        }),
    },
    created () {
        this.getChanceList();
        this.testGet();
        this.testGetZS();
        // this.getNewChanceList();
    },
    methods: {
        ...mapActions({
            getReleaseType: "exhibitor/getReleaseType"
        }),


        updateList () { 
            this.testGet();
            this.testGetZS();
        },

        goDetailInfo (item) {
            // 选择是展商还是个人

            // 没登录就先登录
            let emailLogin = sessionStorage.getItem('emailLogin')
            let accountPassword = sessionStorage.getItem('accountPassword')
            
            // if (!emailLogin && !accountPassword) {
            if (!this.login_is) {
                this.$refs['release'].isActiveChange1()
            } else {
                let logintype =''
                if (emailLogin) {
                    logintype ='个人'
                } else { 
                    logintype ='展商'
                }
                this.$router.push(`/detailGx?id=${item.id}&logintype=${logintype}`);
            }
        },



        async getChanceList () {
            let body = {
                exhibitionId: this.exhibitionId,
                top: 20
            };
            let arr = [];
            let list = await this.getReleaseType(body);
            console.log(list, '返回的商品list');
            if (list && list.length) {
                list.map(c => {
                    if (c.list && c.list.items.length) {
                        c.list.items.map(d => {
                            arr.push(d)
                        })
                    }
                })
                this.chanceTypeList = list;
            } else {
                this.chanceTypeList = [];
            }

            if (arr.length) {
                const pages = [];
                list = arr.slice(0, 9);
                list.forEach((e, i) => {
                    const c = Math.floor(i / 3);
                    if (!pages[c]) {
                        pages[c] = [];
                    }
                    pages[c].push(e);
                });
                this.newChanceList = pages;
            }
            // console.log("商机列表：",this.chanceTypeList);
        },
        async getNewChanceList () {
            let body = {
                ExhibitionId: this.exhibitionId,
                pageSize: this.pageSize,
                pageIndex: this.pageIndex,
            };
            let list = await this.$service.getExChanceAllList(this, body);
            let arr = [];
            list.map(c => {
                if (c.statusId === 1) {
                    arr.push(c);
                }
            })
            const pages = [];
            list = arr.slice(0, 9);
            list.forEach((e, i) => {
                const c = Math.floor(i / 3);
                if (!pages[c]) {
                    pages[c] = [];
                }
                pages[c].push(e);
            });
            this.newChanceList = pages;
        },
        loadList () {
            this.pageIndex++;
            this.getChanceList();
        },
        linkToChance (item) {
            const url = location.origin + `/chance-detailEn?chanceId=${item.id}`;
            window.open(url, "_blank");
            // this.$router.push(`/chance-detail?chanceId=${item.id}`);
        },
        testGet () {
            let body = {
                pageSize: 99,
                pageIndex: 1,
                statusId: 1,
                Wheres: {
                    type: 0,
                    wheres: {
                        WhereGroupOperator: 1,
                        Predicates: [

                            {
                                type: 1,
                                wheres: {
                                    WhereOperator: 0,
                                    Label: 'publishType',
                                    Value: '医疗器械成品',
                                },
                            },
                            {
                                type: 1,
                                wheres: {
                                    WhereOperator: 0,
                                    Label: 'publishType',
                                    Value: '制造供应链',
                                },
                            },
                        ],
                    },
                },
            }
            axios.post('https://api.cmef.com.cn/api/NewRealease/getAllReleaseAndSupply', {
                ...body
            })
                .then(response => {
                    response.data.items.forEach((e) => {
                        e.inTime = e.inTime.substring(0, 10)
                        e.inDate = e.inDate.substring(0, 10)
                        e.endTime = e.endTime ? e.endTime.substring(0, 10) : '无'
                        e.productArea = e.productArea ? (JSON.parse(e.productArea).toString()).replace(/,/g, '/') : ''

                        const categoryArr = []
                        const categoryArr1 = []

                        if (e.productType) {
                            const category = JSON.parse(e.productType)
                            if (category.Value) {
                                categoryArr.push(category.Value)
                                if (category.List[0]) {
                                    categoryArr.push(category.List[0].Value)
                                    if (category.List[0].List) {
                                        categoryArr.push(category.List[0].List[0].Value)
                                    }
                                }
                                e.productType = (categoryArr.toString()).replace(/,/g, '/')
                            }
                        }
                        if (e.supplyProductCategory) {
                            const category1 = JSON.parse(e.supplyProductCategory)
                            if (category1.Value) {
                                categoryArr1.push(category1.Value)
                                if (category1.List[0]) {
                                    categoryArr1.push(category1.List[0].Value)
                                    if (category1.List[0].List) {
                                        categoryArr1.push(category1.List[0].List[0].Value)
                                    }
                                }
                                e.supplyProductCategory = (categoryArr1.toString()).replace(/,/g, '/')
                            }
                        }


                        console.log(categoryArr.toString(), typeof categoryArr.toString())
                    })


                    this.hallList = response.data.items
                    this.pageIndex = response.data.pageIndex
                    this.pageSize = response.data.pageSize
                    console.log(response);
                })
                .catch(function (error) { // 请求失败处理
                    console.log(error);
                });
        },
        testGetZS () {
            let body = {
                pageSize: 99,
                pageIndex: 1,
                statusId: 1,
                Wheres: {
                    type: 0,
                    wheres: {
                        WhereGroupOperator: 0,
                        Predicates: [
                            {
                                type: 1,
                                wheres: {
                                    WhereOperator: 0,
                                    Label: 'publishType',
                                    Value: '招商发布',
                                },
                            },
                        ],
                    },
                },
            }
            axios.post('https://api.cmef.com.cn/api/NewRealease/getAllReleaseAndSupply', {
                ...body
            })
                .then(response => {
                    response.data.items.forEach((e) => {
                        e.inTime = e.inTime.substring(0, 10)
                        e.inDate = e.inDate.substring(0, 10)
                        e.endTime = e.endTime ? e.endTime.substring(0, 10) : '无'
                        e.productArea = e.productArea ? (JSON.parse(e.productArea).toString()).replace(/,/g, '/') : ''

                        const categoryArr = []
                        const categoryArr1 = []

                        if (e.productType) {
                            const category = JSON.parse(e.productType)
                            if (category.Value) {
                                categoryArr.push(category.Value)
                                if (category.List[0]) {
                                    categoryArr.push(category.List[0].Value)
                                    if (category.List[0].List) {
                                        categoryArr.push(category.List[0].List[0].Value)
                                    }
                                }
                                e.productType = (categoryArr.toString()).replace(/,/g, '/')
                            }
                        }
                        if (e.supplyProductCategory) {
                            const category1 = JSON.parse(e.supplyProductCategory)
                            if (category1.Value) {
                                categoryArr1.push(category1.Value)
                                if (category1.List[0]) {
                                    categoryArr1.push(category1.List[0].Value)
                                    if (category1.List[0].List) {
                                        categoryArr1.push(category1.List[0].List[0].Value)
                                    }
                                }
                                e.supplyProductCategory = (categoryArr1.toString()).replace(/,/g, '/')
                            }
                        }


                        console.log(categoryArr.toString(), typeof categoryArr.toString())
                    })


                    this.hallListzs = response.data.items
                    this.pageIndex = response.data.pageIndex
                    this.pageSize = response.data.pageSize
                    console.log(response);
                })
                .catch(function (error) { // 请求失败处理
                    console.log(error);
                });
        },

    },
};
</script>

<style scoped lang='scss'>
.chance {
    background: #f5f5f5;
}

.home-content {
    margin-top: 20px;
    width: 1300px;
    margin: 0 auto 90px;

    .home-t {
        display: flex;
    }

    .home-t-newLeft {
        margin-right: 20px;
        width: 255px;
        height: 566px;
        background: #fff;
        color: #333;
        position: relative;

        .header {
            width: 100%;
            height: 48px;
            background-color: #024c8b;
            text-align: center;
            color: #fff;
            font-size: 16px;
            line-height: 3;
        }

        .matter {
            margin-top: 15px;
            padding-left: 10px;
            display: flex;
            cursor: pointer;

            span {
                display: inline-block;
            }

            span:first-child {
                width: calc(100% - 80px);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            span:last-child {
                color: #666;
            }
        }

        .seeMore {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            line-height: 46px;
            text-align: center;
            color: #999;
            cursor: pointer;
        }
    }

    .home-t-left {
        margin-right: 20px;
        width: 804px;
        background: #fff;
        padding: 20px;
        height: 566px;
    }
}

.home-title {
    font-size: 16px;
    font-weight: bold;
    line-height: 18px;
    color: #333;
    margin-bottom: 20px;
}

.chance-list {
    display: flex;
    flex-wrap: wrap;

    &-one {
        width: 176px;
        height: 234px;
        border: solid 1px #f2f2f2;
        margin: 0 20px 20px 0;
        overflow: hidden;
        cursor: pointer;

        .one-top {
            display: flex;
            align-items: center;
            padding: 10px;
            height: 40px;
            border-bottom: 1px solid #f2f2f2;

            img {
                width: 20px;
                height: 20px;
                border-radius: 3px;
                display: block;
                margin-right: 10px;
                border: solid 1px #e5e5e5;
            }

            p {
                width: 110px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .one-bot {
            padding: 10px;

            p {
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 12px;
                color: #666;
                line-height: 14px;
                margin-bottom: 10px;

                .view {
                    display: flex;
                    align-items: center;

                    i {
                        margin-right: 2px;
                    }
                }
            }

            .one-list-img {
                display: flex;
                flex-wrap: wrap;

                .img {
                    width: 50px;
                    height: 50px;
                    margin: 0 2px 3px 0;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .img:nth-child(3n+3) {
                    margin-right: 0;
                }
            }

            h3 {
                font-size: 14px;
                line-height: 24px;
                color: #333;
            }
        }
    }

    .three {
        margin-bottom: 0;
    }
}

.home-t-left {
    .chance-list-one:nth-child(4n+4) {
        margin: 0 0 20px 0;
    }
}

.home-c-brand {
    margin-top: 20px;
    background: #fff;
    padding: 15px 0;

    h2 {
        font-size: 16px;
        font-weight: bold;
        line-height: 26px;
        color: #333;
        text-align: center;
        padding: 0 15px;
    }
}

.home-b-chance {
    margin-top: 20px;
    background: #fff;
    padding: 15px 22px;

    h2 {
        font-size: 16px;
        font-weight: bold;
        line-height: 26px;
        color: #333;
        text-align: center;
        padding-bottom: 15px;
    }
}

.home-b-chance {
    .chance-list-one:nth-child(6n+6) {
        margin: 0 0 20px 0;
    }
}

.no-msg {
    font-size: 14px;
    color: #666;
    text-align: center;
    padding: 100px 0;
}

.more {
    height: 80px;
    line-height: 80px !important;
    text-align: center;
    width: 100%;
    display: table;
    font-size: 12px !important;
}




.chance {
    margin-top: 20px;
    width: 1300px;
    margin: 0 auto;
    overflow: hidden;
}

.chance-l {

    float: left;
    width: 880px;
}

.chance-r {
    display: inline-block;
    width: 400px;
    background-color: #fff;
    border: 1px solid #f2eded;
    float: right;
}

.chance-item {
    margin-right: 20px;
    width: 435px;
    height: 566px;
    color: #333;
    position: relative;
    float: left;
}

.chance-item:last-child {
    margin-right: 0;
}

.chance-item-header {
    width: 100%;
    height: 48px;
    background-color: #EE1c5D;
    text-align: center;
    color: #fff;
    font-size: 16px;
    line-height: 3;
}

.chance-item-matter {
    margin-top: 15px;
    padding-left: 10px;
    cursor: pointer;
    font-size: 14px;
    vertical-align: top;
    overflow: hidden;
    display: block;
}

.chance-item-info {
    width: calc(100% - 80px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    line-height: 21px;
    height: 21px;
    color: #333;
    float: left;
    margin-right: 2px;
}

.chance-item-date {
    line-height: 21px;
    color: #666;
    display: inline-block;
    float: left;
}

.chance .seeMore {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    line-height: 46px;
    text-align: center;
    color: #999;
    cursor: pointer;
}

.chance-release-title {
    line-height: 48px;
    font-size: 18px;
    padding-left: 20px;
    color: #333;
    font-family: MicrosoftYaHei-Bold;
    border-bottom: 2px solid #c5161b;
    font-weight: 700;
}

.chance-release .cr-box {
    padding: 14px 32px 0 27px;
}

.chance-release .cr-box .layui-form-label {
    width: 80px;
    padding: 9px 10px;
    font-size: 14px;
}

.chance-release .cr-box .layui-input-block {
    margin-left: 80px;
}

.chance-release .cr-box .layui-btn {
    width: 100%;
    background: #EE1c5D;
    background-blend-mode: normal, normal;
    border-radius: 4px;
}

.chance-release .cr-box .layui-form-item {
    padding-top: 20px;
}

.chance-release .cr-box .layui-form-select dl dd.layui-this {
    background: #ff4062;
    background-image: linear-gradient(-90deg, #ff4062, #ff7c3c), linear-gradient(#f2f2f2, #f2f2f2);
    background-blend-mode: normal;
}

.chance-release .cr-box .layui-input,
.chance-release .cr-box .layui-textarea {
    border-radius: 4px;
}

.item {
    background-color: #fff;

    box-shadow: 0 0 0.1rem 0 rgba(0, 0, 0, 0.1);
    padding: 20px 10px;
}

.item_top {
    color: #333;
    display: flex;
}

.line {
    display: flex;
    align-items: flex-end;
    margin-bottom: 0.16rem;

}

.name {
    margin-right: 5px;
    font-weight: 400;
}

.job {
    font-size: 12px;
    color: #666;
}

.phone {
    font-size: 14px;
    color: #333;
}

.info2 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.rn-type {
    display: inline-block;
    font-size: 14px;
    padding: 0px 5px;
    margin-right: 12px;
    margin-bottom: 12px;
    border-width: 1px;
    border-style: solid;
}

/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
    width: 7px;
    height: 7px;
    background-color: #f5f5f5;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #f5f5f5;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    background-color: #c8c8c8;
}

.flex_between_center {
    display: flex;
    justify-content: space-between;
    align-items: center
}
</style>